import React, { useState } from "react"
import Dialog from "@material-ui/core/Dialog"
import DialogTitle from "@material-ui/core/DialogTitle"
import DialogContent from "@material-ui/core/DialogContent"
import DialogActions from "@material-ui/core/DialogActions"
import Typography from "@material-ui/core/Typography"
import IconButton from "@material-ui/core/IconButton"
import CloseIcon from "@material-ui/icons/Close"
import TextField from "@material-ui/core/TextField"
import FormControl from "@material-ui/core/FormControl"
import { withStyles } from "@material-ui/styles"
import LoadingButton from "../LoadingButton"
import styles from "./styles"

const ChangeRateDialog = ({
  classes,
  open,
  clientRate,
  setClientRate,
  crewRate,
  setCrewRate,
  percentage,
  setPercentage,
  submit,
  submitting,
  activeCompany,
  ...props
}) => {
  const [clientRateTouched, setClientRateTouched] = useState(false)
  const [crewRateTouched, setCrewRateTouched] = useState(false)

  const handleClientRateChange = () => event => {
    const newClientRate = event.target.value
    setClientRate(newClientRate)
    if (crewRate === 0 || !clientRateTouched || isNaN(crewRate)) {
      const newCrewRate = newClientRate * ((100 - percentage) / 100)
      setCrewRate(newCrewRate.toFixed(0))
    } else {
      const newPercentage = ((newClientRate - crewRate) / newClientRate) * 100
      setPercentage(Math.round(newPercentage) || 0)
    }
  }

  const handleCrewRateChange = () => event => {
    const newCrewRate = event.target.value
    setCrewRate(newCrewRate)
    if (clientRate === 0 || !crewRateTouched || isNaN(clientRate)) {
      const newClientRate = newCrewRate / ((100 - percentage) / 100)
      setClientRate(newClientRate.toFixed(0))
    } else {
      const newPercentage = ((clientRate - newCrewRate) / clientRate) * 100
      setPercentage(Math.round(newPercentage) || 0)
    }
  }

  const handleTouchedFields = bool => {
    setClientRateTouched(bool)
    setCrewRateTouched(bool)
  }

  const handleClose = () => {
    props.handleCloseChangeRate()
    handleTouchedFields(false)
  }

  return (
    <Dialog onClose={() => handleClose()} open={open}>
      <DialogTitle disableTypography className={classes.dialogTitle}>
        <Typography variant="h6" style={{ color: "#fff" }}>
          Change Role Rate
        </Typography>
        <IconButton onClick={() => handleClose()} aria-label="Close">
          <CloseIcon className={classes.closeButton} />
        </IconButton>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <FormControl>
          <TextField
            id="defaultCrew-client-rate"
            label={activeCompany ? "Client Rate" : "Crew Rate"}
            type="number"
            className={classes.textField}
            value={clientRate}
            onChange={handleClientRateChange()}
            onFocus={() => {
              if (crewRate > 0) {
                return handleTouchedFields(true)
              }
            }}
            onBlur={() => {
              if (clientRate > 0) {
                return handleTouchedFields(true)
              }
            }}
            margin="normal"
          />
        </FormControl>
        {activeCompany && (
          <FormControl>
            <TextField
              id="position-crew-rate"
              label="Crew Rate"
              type="number"
              className={classes.textField}
              value={crewRate}
              onChange={handleCrewRateChange()}
              onFocus={() => {
                if (!isNaN(clientRate) && clientRate > 0) {
                  return handleTouchedFields(true)
                }
              }}
              onBlur={() => {
                if (!isNaN(crewRate) && crewRate > 0) {
                  return handleTouchedFields(true)
                }
              }}
              margin="normal"
            />
          </FormControl>
        )}
        {activeCompany && (
          <FormControl>
            <Typography className={classes.percentage}>
              {`${
                clientRate === 0 && crewRate === 0
                  ? 12
                  : percentage < 0
                    ? 0
                    : isNaN(percentage)
                      ? 0
                      : percentage
              } %`}
            </Typography>
          </FormControl>
        )}
      </DialogContent>
      <DialogActions>
        <LoadingButton
          color="primary"
          buttonclicked={submit}
          working={submitting}
          type="button"
          disabled={submitting}
        >
          Save
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}

export default withStyles(styles)(ChangeRateDialog)
